import React, { Component } from "react";
import gql from "graphql-tag";

import _ from "lodash";

import Fuse from "fuse.js";
import { connect } from "react-redux";
import { Query } from "react-apollo";
import { selectRelation, deselectRelation } from "../../actions/select_actions";
import { Box } from "reflexbox";

import ToggleForm from "../../common/Buttons/_ToggleForm";

import { flatten } from "../../utils";
import RelationCredentialsDialog from "./_RelationCredentialsDialog";
import {
  DetailsList,
  Selection,
  ConstrainMode
} from "office-ui-fabric-react/lib/DetailsList";
import { SearchBox } from "office-ui-fabric-react/lib/SearchBox";
import { CommandBarButton } from "office-ui-fabric-react/lib/Button";
import ConfirmDeleteDialog from "../../common/Forms/_ConfirmDeleteDialog";
import { Icon } from "office-ui-fabric-react/lib/Icon";

import ExcelFile from "../../export/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "../../export/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "../../export/ExcelPlugin/elements/ExcelColumn";

const fuseConfig = {
  caseSensitive: false,
  tokenize: true,
  shouldSort: true,
  threshold: 0.2,
  keys: ["name", "role", "countryByCountryId.iso", "city"]
};

class Relations extends Component {
  constructor(props) {
    super();

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({ selectedItems: this._selection.getSelection() });
      }
    });

    this.state = {
      prevProps: [],
      items: [],
      selectedItems: [],
      columns: _columns
    };
  }

  static getDerivedStateFromProps(props, state) {
    const prevProps = state.prevProps;
    
    if (prevProps.items !== props.items) {
      return { items: props.items, prevProps: props };
    } else return null;
  }

  _handleSearch = text => {
    const fuse = new Fuse(this.state.items, fuseConfig);
    this.setState({ items: text ? fuse.search(text) : this.props.items });
  };

  _onColumnClick = (event, column) => {
    let { items, columns } = this.state;
    let isSortedDescending = column.isSortedDescending;
    if (column.isSorted) {
      isSortedDescending = !isSortedDescending;
    }
    if (isSortedDescending) {
      items = _.sortBy(items, column.fieldName);
    } else {
      items = _.reverse(_.sortBy(items, column.fieldName));
    }
    this.setState({
      items: items,
      columns: columns.map(col => {
        col.isSorted = col.key === column.key;
        if (col.isSorted) {
          col.isSortedDescending = isSortedDescending;
        }
        return col;
      })
    });
  };

  render() {
    const exelData = this.state.items.map(item => flatten(item));

    return (
      <Box>
        <Box flex align="center">
          <ToggleForm form="relation" addOrEdit="add" />
          <ToggleForm form="relation" addOrEdit="edit" />
          <RelationCredentialsDialog
            id={
              this.state.selectedItems.length !== 1
                ? ""
                : this.state.selectedItems[0].id
            }
          />
          <ConfirmDeleteDialog
            model="relation"
            text="Delete"
            items={this.state.selectedItems}
          />
          <ExcelFile
            element={
              <CommandBarButton
                styles={{ root: { padding: "10px" } }}
                disabled={this.state.selectedItems.length === 0}
                iconProps={{ iconName: "Download" }}
                text="Save .xls"
              />
            }
          >
            <ExcelSheet data={exelData} name="Relations">
              <ExcelColumn label="Relation id" value="id" />
            </ExcelSheet>
          </ExcelFile>
          <Box ml={1}>
            <SearchBox
              className="searchBox"
              placeholder="Search"
              onChange={this._handleSearch}
            />
          </Box>
        </Box>
        <Box>
          <div className="list-container" data-is-scrollable="true">
            <DetailsList
              className="list-body"
              items={this.state.items}
              setKey="key"
              columns={this.state.columns}
              listProps={{ usePageCache: true }}
              compact
              layoutMode={ConstrainMode.fixedColumns}
              constrainMode={ConstrainMode.horizontalConstrained}
              selectionPreservedOnEmptyClick={true}
              onActiveItemChanged={(item, index) =>
                this.props.selectRelation(item)
              }
              selection={this._selection}
              onColumnHeaderClick={this._onColumnClick}
            />
          </div>
        </Box>
      </Box>
    );
  }
}

const _columns = [
  {
    key: "edit",
    iconName: "",
    isIconOnly: true,
    fieldName: "",
    minWidth: 5,
    maxWidth: 5,
    isPadded: false,
    onRender: item => {
      return <span />;
      // return <ToggleForm form="contact" addOrEdit="edit" />;
    }
  },
  {
    key: "file",
    iconName: "Page",
    isIconOnly: true,
    fieldName: "storagesByRelationId.nodes",
    minWidth: 5,
    maxWidth: 5,
    isPadded: false,
    onRender: item => {
      return (
        <div>
          {item.storagesByRelationId &&
          item.storagesByRelationId.nodes.length > 0 ? (
            <div>
              <Icon iconName="Attach" />{" "}
              {item.storagesByRelationId.nodes.length}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    }
  },
  {
    key: "name",
    name: "Name",
    fieldName: "name",
    minWidth: 50,
    maxWidth: 100
  },
  {
    key: "code",
    name: "Code",
    fieldName: "code",
    minWidth: 50,
    maxWidth: 100
  },
  {
    key: "role",
    name: "Role",
    fieldName: "role",
    minWidth: 50,
    maxWidth: 100
  },
  {
    key: "doorCode",
    name: "Door code",
    fieldName: "doorCode",
    minWidth: 50,
    maxWidth: 100
  },
  {
    key: "adres",
    name: "Adres",
    fieldName: "adres",
    minWidth: 50,
    maxWidth: 100
  },
  {
    key: "postindex",
    name: "Postindex",
    fieldName: "postindex",
    minWidth: 50,
    maxWidth: 100
  },
  {
    key: "city",
    name: "City",
    fieldName: "city",
    minWidth: 50,
    maxWidth: 100
  },
  {
    key: "countryByCountryId.name",
    name: "Country",
    fieldName: "countryByCountryId.name",
    minWidth: 60,
    maxWidth: 60,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <span>{item.countryByCountryId && item.countryByCountryId.iso}</span>;
    }
  }
];

class RelationsTableContainer extends Component {
  render() {
    const { selectRelation, deselectRelation } = this.props;

    return (
      <Query query={ALL_RELATIONS}>
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error :(</p>;

          const items = _.sortBy(data.allRelations.nodes, ["name"]);

          return (
            <Relations
              items={items}
              selectRelation={selectRelation}
              deselectRelation={deselectRelation}
            />
          );
        }}
      </Query>
    );
  }
}

export const ALL_RELATIONS = gql`
  query allRelations {
    allRelations(orderBy: NAME_ASC) {
      nodes {
        id
        role
        name
        code
        adres
        postindex
        city
        countryId
        vat
        eori
        kvk
        loadingAddr
        loadingRoute
        doorCode
        about
        color
        createdAt
        updatedAt
        contactsByRelationId {
          nodes {
            id
          }
        }
        countryByCountryId {
          id
          nicename
          name
          iso
        }
      }
    }
  }
`;

export default connect(null, {
  selectRelation: selectRelation,
  deselectRelation: deselectRelation
})(RelationsTableContainer);



// WEBPACK FOOTER //
// ./src/views/Relations/_RelationTable.js